import { UserData } from 'src/app/models/user-data';
import { GraphqlUserDatatOutput } from '../models/output/user-data-output.model';

/**
 * Maps user data as received from the authentication source to internal model.
 * @param input GraphQL output of user data.
 * @returns Internal model.
 */
export function convertGraphqlUserDataOutputToUserData(input: GraphqlUserDatatOutput): UserData {
	return {
		userName: input.Username,
		sessionID: input.SessionUID,
		companyName: input.Company,
		email: input.Email,
	};
}
